<template>
  <div class="row card borderless-card" style="box-shadow: none">
    <div class="col-12" style="/*padding:0*/">
      <div class="d-flex" style="padding-top: 16px; padding-bottom: 16px">
        <div class="form-group has-search flex-grow-1">
          <span
            class="fa fa-search form-control-feedback"
            style="margin-top: 0"
          ></span>
          <input
            type="text"
            class="form-control upcoming-tasks-search"
            v-model="searchQuery"
            aria-controls="datatables"
            placeholder="Search Task"
          />
        </div>
        <div class="newTaskParentDiv">
          <!-- <button class="newTask" @click="handleCreateTodo">
            <i class="fa fa-plus" aria-hidden="true"></i>
            New task
          </button>-->
        </div>
      </div>
      <div class="upcoming-tasks-line"></div>
      <tabulator-card
        id="theMainTableBoxTransactionDetails"
        class="completedTasks todos-table-parent"
        :tableData="todoData.data"
        :tableOptions="todoData.options"
        :tableColumns="todoData.columns"
        @tabulatorDetails="getTabulatorDetails"
      ></tabulator-card>
      <!-- <div id="completedTaskTable">
        <div id="thecompletedTaskTable">
          <div class="tabulator" ref="completedTable" style="width:100%;height:100%;"></div>
        </div>
      </div>-->
      <dialogtodo v-model="dialogTodoData" v-if="showDialogModal"></dialogtodo>
    </div>
    <el-dialog
      center
      width="400px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="deleteFlag"
    >
      <div class="row" style="padding-left: 15px; padding-right: 15px">
        <div style="padding-left: 30px">
          Are you sure you want to Delete this To-do?
        </div>
      </div>
      <div class="col-12 d-flex">
        <div
          class="col-xl edit-company-action-button-row"
          style="padding-right: 25px"
        >
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancelDeleteTodo"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="handleDeleteTodo(deleteData)"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
          >
            Delete
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { TabulatorCard } from "../../../components/index";
import { mapGetters } from "vuex";
import moment from "moment";
import DialogAddTodo from "../Dialogs/DialogAddTodo";
import api from "../../../axios_api";
import { Dialog } from "element-ui";

export default {
  name: "completed-tasks",
  components: {
    TabulatorCard,
    [DialogAddTodo.name]: DialogAddTodo,
    [Dialog.name]: Dialog,
  },
  props: {
    data: Array,
  },
  data() {
    return {
      showDialogModal: false,
      dialogTodoData: {},
      searchQuery: "",
      tabulator: null,
      deleteFlag: false,
      deleteData: {},
    };
  },
  watch: {
    searchQuery: {
      handler: function (newData) {
        this.tabulator.clearFilter(true);
        this.tabulator.setFilter([
          [
            { field: "priority", type: "like", value: this.searchQuery },
            { field: "due_date", type: "like", value: this.searchQuery },
            { field: "action_type", type: "like", value: this.searchQuery },
            { field: "name", type: "like", value: this.searchQuery },
            { field: "task", type: "like", value: this.searchQuery },
          ],
        ]);
      },
    },
    todoData: {
      handler: function (nData) {
        if (this.tabulator) this.tabulator.replaceData(nData.data);
      },
    },
  },
  mounted() {
    let self = this;
    //self.tabulator = new Tabulator(self.$refs.completedTable, self.todoData);
    this.$store
      .dispatch("todo/getCompleteTodos", this.$route.params.workspace_id)
      .then((data) => {
        // self.tabulator = new Tabulator(self.$refs.table, self.todoData);
        this.todoData;
      })
      .catch((error) => {
        console.log("completed tasks error", error);
      });
  },
  computed: {
    ...mapGetters("team", ["getAllUsers"]),
    ...mapGetters("todo", ["current_component"]),
    ...mapGetters("todo", ["completed_todos"]),
    ...mapGetters("role", ["checkRole"]),
    todoData() {
      let todos = JSON.parse(JSON.stringify(this.completed_todos));
      var teams = this.getAllUsers;
      for (var i = 0; i < todos.length; i++) {
        todos[i].index = i;
        todos[i].assignedName = [];
        todos[i].modified = moment(todos[i].modified).format("MM/DD/YYYY");
        todos[i].due_date = moment(todos[i].due_date).format("MM/DD/YYYY");
        todos[i].task = `${todos[i].title} : ${todos[i].description}`;
        todos[i].assigned_to =
          typeof todos[i].assigned_to == "string"
            ? [todos[i].assigned_to]
            : todos[i].assigned_to;

        todos[i].assigned_to.map((res) => {
          teams.find((item) => {
            if (item.account._id == res) {
              if (item.account.firstName != item.account.lastName) {
                todos[i].assignedName.push(
                  `${item.account.firstName} ${item.account.lastName}`
                );
              } else {
                todos[i].assignedName.push(item.account.firstName);
              }
            }
            return item.account._id == res;
          });
        });
        todos[i].name = todos[i].assignedName.toString();
      }
      return {
        data: todos,
        options: {
          layout: "fitColumns",
          tooltips: true,
          pagination: "local",
          paginationSize: 20,
          paginationSizeSelector: true,
          tooltipsHeader: true,
          placeholder: "No records to view",
        },
        columns: this.tableColumns,
      };
    },
    tableColumns() {
      const self = this;
      return [
        {
          title: "Priority",
          field: "priority",
          sorter: "string",
          minWidth: 110,
          resizable: false,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            let priority = cell.getData().priority;
            let response;
            if (priority == "urgent") {
              response = `<div class="badge urgent-priority-pill px-3">${priority}</div>`;
            } else if (priority == "medium") {
              response = `<div class="badge medium-priority-pill px-3">${priority}</div>`;
            } else {
              response = `<div class="badge low-priority-pill px-3">${priority}</div>`;
            }
            return response;
          },
        },
        {
          title: "Due Date",
          field: "due_date",
          sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            return new Date(a) - new Date(b); //you must return the difference between the two values
          },
          minWidth: 130,
        },
        {
          title: "Action",
          field: "action_type",
          sorter: "string",
          minWidth: 150,
          resizable: false,
        },
        {
          title: "Assignee",
          field: "name",
          sorter: "string",
          minWidth: 250,
          resizable: false,
        },
        {
          title: "Task",
          field: "task",
          sorter: "string",
          minWidth: 485,
          resizable: true,
        },
        {
          title: "",
          field: "",
          sorter: "string",
          width: 30,
          headerSort: false,
          resizable: false,
          cellClick: function (e, cell) {
            if (self.checkRole != "Guest") {
              let data = cell.getData();
              self.deleteData = data;
              self.deleteFlag = true;
            }
          },
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            return self.checkRole != "Guest"
              ? `<i class="fas fa-trash"></i>`
              : "";
          },
        },
      ];
    },
    moment() {
      return moment;
    },
  },
  methods: {
    getTabulatorDetails(list) {
      this.tabulator = list;
    },
    handleCreateTodo() {
      this.showDialogModal = true;
      this.dialogTodoData = {
        isShow: true,
        isCreate: true,
        data: {
          priority: "medium",
          due_date: new Date().setDate(new Date().getDate() + 3),
          is_quick_task: false,
          status: "New",
        },
        assigned_to: this.$route.params.account_id,
      };
    },
    handleEditTodo(item, index) {
      let todoData = JSON.parse(JSON.stringify(item));
      this.$store.commit("todo/setTodoIndex", {
        _id: todoData._id,
        index: index,
      });
      this.showDialogModal = true;
      this.dialogTodoData = {
        isShow: true,
        isCreate: false,
        data: todoData,
        assigned_to: todoData.assigned_to,
      };
    },
    handleCancelDeleteTodo() {
      this.deleteData = {};
      this.deleteFlag = false;
    },
    handleDeleteTodo(data) {
      api
        .delete(`/todo/${data._id}`, {})
        .then((data) => {
          //this.$store.commit("todo/EditTodoData", data.data.encrypt.data);
          this.$store.dispatch(
            "todo/getAllTodos",
            this.$route.params.workspace_id
          );
          this.$store.getters["todo/componentTodos"](
            this.current_component,
            this.$route.params.workspace_id
          );
          this.deleteFlag = false;
          this.$toaster.success("Deleted successfully.");
        })
        .catch((error) => {
          console.log(error);
          this.$toaster.error("Failed to Delete Todo..!!");
        });
    },
  },
};
</script>
<style>
.completedTasks .card-body {
  padding-left: 0;
  padding-right: 0;
}
</style>